const permissions = {
  '/admin/updates': {
    'Status Solutions': { 'Admin': true, 'Standard': false },
    'Corporate': { 'Admin': false, 'Standard': false },
    'Facility': { 'Admin': false, 'Standard': false },
    'Family': { 'Admin': false, 'Standard': false }
  },
  '/admin/facilities': {
    'Status Solutions': { 'Admin': true, 'Standard': true },
    'Corporate': { 'Admin': false, 'Standard': false },
    'Facility': { 'Admin': false, 'Standard': false },
    'Family': { 'Admin': false, 'Standard': false }
  },
  '/admin/corporations': {
    'Status Solutions': { 'Admin': true, 'Standard': true },
    'Corporate': { 'Admin': false, 'Standard': false },
    'Facility': { 'Admin': false, 'Standard': false },
    'Family': { 'Admin': false, 'Standard': false }
  },  
  '/admin/users': {
    'Status Solutions': { 'Admin': true, 'Standard': false },
    'Corporate': { 'Admin': true, 'Standard': false },
    'Facility': { 'Admin': true, 'Standard': false },
    'Family': { 'Admin': true, 'Standard': false }
  },
  '/admin/groups': {
    'Status Solutions': { 'Admin': true, 'Standard': false },
    'Corporate': { 'Admin': true, 'Standard': false },
    'Facility': { 'Admin': true, 'Standard': false },
    'Family': { 'Admin': false, 'Standard': false }  
  },  
  '/admin/modules': {
    'Status Solutions': { 'Admin': true, 'Standard': false },
    'Corporate': { 'Admin': true, 'Standard': false },
    'Facility': { 'Admin': true, 'Standard': false },
    'Family': { 'Admin': false, 'Standard': false }   
  },  
  '/devices': {
    'Status Solutions': { 'Admin': true, 'Standard': true },
    'Corporate': { 'Admin': true, 'Standard': true },
    'Facility': { 'Admin': true, 'Standard': true },
    'Family': { 'Admin': false, 'Standard': false } 
  },
  '/calendar': {
    'Status Solutions': { 'Admin': false, 'Standard': false },
    'Corporate': { 'Admin': false, 'Standard': false },
    'Facility': { 'Admin': true, 'Standard': true },
    'Family': { 'Admin': true, 'Standard': true } 
  },
  '/monitoredindividual': {
    'Status Solutions': { 'Admin': false, 'Standard': false },
    'Corporate': { 'Admin': false, 'Standard': false },
    'Facility': { 'Admin': true, 'Standard': true },
    'Family': { 'Admin': false, 'Standard': false } 
  },
  '/reports': {
    'Status Solutions': { 'Admin': true, 'Standard': true },
    'Corporate': { 'Admin': true, 'Standard': true },
    'Facility': { 'Admin': true, 'Standard': true },
    'Family': { 'Admin': false, 'Standard': false } 
  },  
  '/notes': {
    'Status Solutions': { 'Admin': false, 'Standard': false },
    'Corporate': { 'Admin': false, 'Standard': false },
    'Facility': { 'Admin': true, 'Standard': true },
    'Family': { 'Admin': true, 'Standard': true }     
  }, 
  '/unit':{
    'Status Solutions': { 'Admin': false, 'Standard': false },
    'Corporate': { 'Admin': false, 'Standard': false },
    'Facility': { 'Admin': true, 'Standard': true },
    'Family': { 'Admin': false, 'Standard': false } 
  }
};

const defaults = {
  'Status Solutions': {
    'Admin': '/admin/updates',
    'Standard': '/admin/facilities'
  },
  'Corporate': {
    'Admin': '/admin/modules',
    'Standard': '/admin/modules'
  },
  'Facility': {
    'Admin': '/admin/modules',
    'Standard': '/admin/modules'
  },
  'Family': {
    'Admin': '/admin/users',
    'Standard': '/' // Family users cannot view admin area
  }
};

const states = {
  '/admin/updates': {
    currentPanel: 'Organizations',
    currentSubPanel: 'New & Updated'
  },
  '/admin/facilities': {
    currentPanel: 'Organizations',
    currentSubPanel: 'Facilities'
  },
  '/admin/corporations': {
    currentPanel: 'Organizations',
    currentSubPanel: 'Corporations'
  },  
  '/admin/modules': {
    currentPanel: 'Modules',
    currentSubPanel: ''
  },
  '/admin/users': {
    currentPanel: 'Users & Groups',
    currentSubPanel: 'Users'
  },
  '/admin/groups': {
    currentPanel: 'Users & Groups',
    currentSubPanel: 'Groups'
  }
};
  
export function userCanVisitRoute(user, route) {
  if (!user || !route || !permissions[route] || !user.groupTypeString) return false;

  const AccessLevel = user.isAdmin ? 'Admin': 'Standard';

  return permissions[route][user.groupTypeString][AccessLevel];
}

export function getDefaultRouteForUser(user) {
  if (!user || !user.groupTypeString) return '/';

  const AccessLevel = user.isAdmin ? 'Admin': 'Standard';

  return defaults[user.groupTypeString][AccessLevel];
}

export function getStateFromRoute(route) {
  if (!route || !states[route]) return { };

  return states[route];
}